import { render, staticRenderFns } from "./hqglBenefitsGrantAudit.vue?vue&type=template&id=234f82ae&scoped=true&"
import script from "./hqglBenefitsGrantAudit.vue?vue&type=script&lang=js&"
export * from "./hqglBenefitsGrantAudit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234f82ae",
  null
  
)

export default component.exports